export default __webpack_public_path__ + "static/media/test.e1cbe504.svg";